/**
 * Credits API — fetch balance.
 *
 * RETIRED PATH (2026-10-28): mms-commerce `/api/customer/credits/balance` was
 * disabled 2026-09-04 (H-079 — Shopify native wallet owns customer credit),
 * so every call 404s. Short-circuit to null until a replacement read model
 * lands; callers already degrade to balance-hidden.
 */

export async function fetchCreditsStatus() {
  return null
}
